import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { formatMoeda } from '../../utils';

const ValorField = (props) => {
  const record = useRecordContext(props);
  const source = props.source || 'valor';
  const valor = record ? (record.record ? record.record[source] : 0) : 0;
  // o risco de isenção só vale para o valor total
  const isento =
    source === 'valor' && record && record.record ? record.record.isento : false;

  return (
    <>
      {isento ? (
        <div>
          <div
            style={{
              color: 'red',
              textDecoration: 'line-through',
              fontSize: '12px',
            }}
          >
            {`${formatMoeda(valor)}`}
          </div>
          <div
            style={{
              backgroundColor: 'yellow',
              fontWeight: 'bold',
              fontSize: '15px',
            }}
          >
            {`${formatMoeda(0)}`}
          </div>
        </div>
      ) : (
        <div>{`${formatMoeda(valor)}`}</div>
      )}
    </>
  );
};

export default ValorField;
